module.exports = __webpack_public_path__ + "static/media/3-circle-onhold.da31a144.svg";